import { cur } from '@/lib/currency';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { useNavigate } from 'react-router-dom';

export const DuesDetailDialog = ({ open, onOpenChange, data = [] }) => {
  const navigate = useNavigate();
  const go = (entry) => { if (entry.link) { onOpenChange(false); navigate(entry.link); } };
  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl max-h-[80dvh] overflow-y-auto" data-testid="dues-detail-dialog">
      <DialogHeader>
        <DialogTitle className="font-outfit">Branch Dues - Transaction Details</DialogTitle>
      </DialogHeader>
      {data.length === 0 ? (
        <p className="text-center text-muted-foreground py-8">No cross-branch transactions found</p>
      ) : (
        <div className="border rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-muted/50">
                <tr>
                  <th className="text-left px-3 py-2 font-medium">Date</th>
                  <th className="text-left px-3 py-2 font-medium">Type</th>
                  <th className="text-left px-3 py-2 font-medium">From Branch</th>
                  <th className="text-left px-3 py-2 font-medium">To Branch</th>
                  <th className="text-right px-3 py-2 font-medium">Amount</th>
                  <th className="text-left px-3 py-2 font-medium">Description</th>
                </tr>
              </thead>
              <tbody>
                {data.map((entry, i) => (
                  <tr key={i} className={`border-t hover:bg-muted/50 ${entry.link ? 'cursor-pointer' : ''}`} onClick={() => go(entry)} title={entry.link ? 'Open source record' : ''} data-testid={`dues-entry-${i}`}>
                    <td className="px-3 py-2 text-xs">{entry.date ? new Date(entry.date).toLocaleDateString() : '-'}</td>
                    <td className="px-3 py-2">
                      <Badge variant="outline" className={`text-[10px] capitalize ${
                        entry.type === 'transfer' ? 'bg-info/10 border-info/30 text-info' :
                        entry.type === 'expense' ? 'bg-error/10 border-error/30 text-error' :
                        entry.type === 'salary' ? 'bg-purple-50 border-purple-200 text-purple-700' :
                        'bg-warning/10 border-warning/30 text-warning'
                      }`}>{entry.type.replace('_', ' ')}</Badge>
                    </td>
                    <td className="px-3 py-2 text-sm font-medium">{entry.from_branch}</td>
                    <td className="px-3 py-2 text-sm">{entry.to_branch}</td>
                    <td className="px-3 py-2 text-right font-bold text-sm">{cur()} {entry.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className="px-3 py-2 text-xs text-muted-foreground truncate max-w-[200px]">{entry.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="px-3 py-2 bg-muted/50 text-xs text-muted-foreground border-t">
            {data.length} cross-branch transactions
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
  );
};
